import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import { Link } from 'react-router-dom'
import { Element } from 'react-scroll'
import './styles.css'

function ProfileSummary({ className = '', name, photo, slug, tagline = '', variant = 'artist', elementName = '' }) {
  return (
    <div className={classnames('profile-summary', { [className]: className })}>
      <Element name={elementName}>
        <Link
          className="profile-summary-wrap"
          to={`/${variant === 'teamMember' ? 'the-team' : 'artists'}/${slug}`}
        >
          <div
            className="profile-summary__photo"
            aria-label="Profile image"
            style={{ backgroundImage: `url(${photo})` }}
          />
          <div className="profile-summary-info">
            <h3 className="profile-summary-info__name">{name}</h3>
            <p className="profile-summary-info__tagline">{tagline}</p>
          </div>
        </Link>
      </Element>
    </div>
  )
}

ProfileSummary.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  photo: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  tagline: PropTypes.string,
  variant: PropTypes.oneOf(['artist', 'teamMember']),
  elementName: PropTypes.string
}

export default ProfileSummary
